/*
    Implementation to use redux form with react-select.

    this is reusable field for the text, email, password, number
*/
import React, { useEffect, useState } from 'react';
import lodash from 'lodash';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

const UpwardReduxSelect = ({ input, options, placeholder, meta:{ touched, error }, selectOption, ...custom }) => {
   if (!input.value && options && options.length === 1 && selectOption) {
      selectOption(options[0]);
   }

   return (
      <Select
         {...input}
         onChange={ (value) => input.onChange(value) }
         onBlur={ () => input.onBlur(input.value) }
         options={options}
         {...custom}
         className={ `react-select-container${ touched && error ? ' is-invalid ' : '' }` }
         classNamePrefix='react-select'
         blurInputOnSelect={false}
         placeholder={placeholder || 'Select'}
      />
   );
};

export const UpwardReduxSelectWithChild = ({ input, meta: { touched, error, warning }, childComponent: ChildComponent, ...custom }) => {
   return (
      <ChildComponent
         {...input}
         value={input.value}
         onChange={ (value) => {
            input.onChange(value);
         }}
         onBlur={() => input.onBlur(input.value) }
         blurInputOnSelect={false}
         className={ touched && error ? ' is-invalid ' : '' }
         {...custom}
      />
   );
};

// TEMPORARY... used for patch. Waiting for DE Form Page to be ported out of Redux Form...
export const UpwardReduxSelectOnChangeNonEventWithChild = ({ input, meta: { touched, error, warning }, childComponent: ChildComponent, handleNonEventChange, ...custom }) => {
   return (
      <ChildComponent
         {...input}
         value={input.value}
         onChange={ (value) => {
            if (handleNonEventChange) {
               handleNonEventChange(value);
            } else {
               console.error('handleNonEventChange argument is required.');
            }
         }}
         onBlur={() => input.onBlur(input.value) }
         blurInputOnSelect={false}
         className={ touched && error ? ' is-invalid ' : '' }
         {...custom}
      />
   );
};

export const UpwardReduxSelectFromRemote = ({ input, api, apiOptions = {}, responseMapper, placeholder, meta:{ touched, error, warning }, ...custom }) => {
   const [options, setOptions] = useState([]);

   useEffect(() => {
      const subscription = api(apiOptions).subscribe((response) => {
         if (response?.length) {
            if (lodash.isFunction(responseMapper)) {
               setOptions(responseMapper(response))
            } else {
               setOptions(response);
            }
         } else {
            setOptions([{
               value: 'ERROR',
               label: 'error fetching options',
            }]);
         }
      });

      return () => {
         subscription.unsubscribe();
      };
   }, []);

   return (
      <Select
         {...input}
         onChange={ (value) => input.onChange(value) }
         onBlur={ () => input.onBlur(input.value) }
         options={options}
         {...custom}
         className={ `react-select-container${ touched && error ? ' is-invalid ' : '' }` }
         classNamePrefix='react-select'
         blurInputOnSelect={false}
         placeholder={placeholder || 'Select'}
      />
   );
};

export const UpwardCreateableReduxSelect = ({ input, options, placeholder, meta:{ touched, error, warning }, ...custom }) => {
   return (
      <CreatableSelect
         {...input}
         onChange={ (value) => input.onChange(value) }
         onBlur={ () => input.onBlur(input.value) }
         options={options}
         {...custom}
         className={ `react-select-container${ touched && error ? ' is-invalid ' : ''}` }
         classNamePrefix='react-select'
         blurInputOnSelect={false}
         placeholder={placeholder || ''}
      />
   );
};

export default UpwardReduxSelect;
